export var setFocus = function (element) {
    if (element && element.focus) {
        element.focus();
    }
};
